import React from "react";
import { Alert, Box } from "@mui/material";
import PageContainer from "../../Shared/PageContainer/PageContainer";
import DonationLinkReviewTable from "../../../Components/DonationLinkReview/DonationLinkReviewTable";
import { adminFromLocalStg } from "../../../helpers/AdminFromLocalStorage/AdminFromLocalStorage";

const DonationLinkReview = () => {
  const admin = adminFromLocalStg("admin");
  const isSuperAdmin = admin?.role === "superadmin";

  if (!isSuperAdmin) {
    return (
      <PageContainer pt={"50px"} title="Donation Link Review">
        <Box sx={{ p: 4 }}>
          <Alert severity="warning" sx={{ borderRadius: 2 }}>
            Donation Link Review is available to Super Admins only. You do not
            have access to review custom payment links.
          </Alert>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer pt={"50px"} title="Donation Link Review">
      <div className="RightFeedContainer">
        <DonationLinkReviewTable />
      </div>
    </PageContainer>
  );
};

export default DonationLinkReview;
